import React, { Component } from "react";
import { View, StyleSheet, TouchableHighlight } from "react-native";
import Text from "../../components_v2/TextFont";
import { ArButton } from "../../argon-ui";
import MaterialDropdown from "../../components_v2/MaterialDropdown";
import { translate } from "../../locales/translate";
import FontAwesomeIcon from "../../components_v2/FontAwesomeIcon";
import { faTrash } from "../../../assets/consts/faCharCodes";
import Theme from "../../argon-ui/Theme";
const ddpItems = ["areaIsArmed", "areaIsDisarmed"];

class OptionalConditionAreaArmed extends Component {
  constructor(props) {
    super(props);
    let { id, areaId, areaName, areaExpected } = this.props;
    this.state = {
      id,
      areaId,
      areaName,
      areaExpected,
    };
  }

  componentDidMount() {}

  handleOnDelete = () => {
    this.props.onDelete && this.props.onDelete(this.state.id);
  };

  handleOnChange = (expected) => {
    this.setState({ areaExpected: expected  }, () => {
      this.props.onExpectationChange &&
        this.props.onExpectationChange(expected);
    });
  };
  render() {
    return (
      <View style={styles.container}>
        <View style={{ alignItems: "flex-start" }}>
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            style={{ marginStart: 5 }}
          >
            {this.state.areaName}:{" "}
          </Text>
        </View>
        <View style={styles.fieldsRow}>
          <View style={{ flex: 1, marginHorizontal: 5 }}>
            <MaterialDropdown
              data={ddpItems.map((v) => {
                return { value: v, label: translate(`scenario.${v}`) };
              })}
              value={this.state.areaExpected ? ddpItems[0] : ddpItems[1]}
              onChangeText={(value, index, data) => {
                this.handleOnChange(index == 0);
              }}
            />
          </View>
          <TouchableHighlight
            underlayColor="transparent"
            style={{
              width: 35,
              height: 35,
              backgroundColor: Theme.COLORS.ERROR,
              justifyContent: "center",
              alignItems: "center",
              borderRadius: 5,
            }}
            onPress={this.handleOnDelete}
          >
            <FontAwesomeIcon icon={faTrash} color="#FFF" size={16} />
          </TouchableHighlight>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    marginVertical: 5,
    padding: 5,
    paddingVertical: 5,
    paddingEnd: 16,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: "#9C26B030",
    backgroundColor: "#9C26B010",
  },
  fieldsRow: {
    flexDirection: "row",
    alignItems: "center",
  },
});

export default OptionalConditionAreaArmed;
